import styled from 'styled-components'
import { colors } from '../../assets/colors'

const Label = styled.span`
  font-size: 10px;
  color: ${colors.mediumGrey};
`

export default Label
